import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { OfbizList, RemoteFormData, ColumnFieldTitle, OfbizField } from '@urbannex/ofbiz-forms';
import { getFields, getColumnFieldTitles } from '@urbannex/view-containers';
import { PART_FORMS } from '../../../../forms';

@Component({
  selector: 'pty-customer-eft-account',
  templateUrl: './customer-eft-account.component.html',
  styleUrls: ['./customer-eft-account.component.scss']
})
export class CustomerEftAccountComponent implements OnChanges {
  @Input() partyId:string;

  listForm:OfbizList;
  
  title:"Credit Card";
  fieldOptions:any;
  state$:any;
  isLookup:false;
  cardMode:true;
  remoteFormData:RemoteFormData;
  columnFieldTitles:ColumnFieldTitle[];
  columnFields:OfbizField[];
  listOptions:any;
  hasRemoteData = false;

  constructor(){}

  ngOnChanges(changes: SimpleChanges): void {
    if(changes["partyId"]){
      this.listForm = new OfbizList({
        listFormName:"CustomerEftPaymentMethods",
        listFormLocation: "component://kwikstore/widget/PartyForms.xml",
        columnFields: getFields("CustomerEftPaymentMethods", PART_FORMS),
        columnFieldTitles:getColumnFieldTitles("CustomerEftPaymentMethods",PART_FORMS),
        //fieldFormFields:any,
        listType:"list",
        emptyListMessage:"No Postal Addresses found for this customer",
        remoteFormData:{
          formData:{
            formName:"CustomerEftPaymentMethods",
            formLocation:"component://kwikstore/widget/PartyForms.xml",
            viewIndex:0,
            listType:"grid",
          },
          parameters:{"partyId":this.partyId,"paymentMethodTypeId":"EFT_ACCOUNT"},
          endPoint:"partymgr"
        }
      })
      this.remoteFormData = {
        formData:{
          formName:"CustomerEftPaymentMethods",
          formLocation:"component://kwikstore/widget/PartyForms.xml",
          viewIndex:0,
          listType:"grid",
        },
        parameters:{"partyId":this.partyId,"paymentMethodTypeId":"EFT_ACCOUNT"},
        endPoint:"partymgr"
      };
      this.columnFields = getFields("CustomerEftPaymentMethods",PART_FORMS),
      this.columnFieldTitles = getColumnFieldTitles("CustomerEftPaymentMethods",PART_FORMS),
      this.state$.remoteFormData = this.remoteFormData;
      this.hasRemoteData = true;
      console.log(this.remoteFormData);
    }
  }
}
